<wizard *ngIf="contentLoaded" class="content-padded container-fluid" navBarLocation="top" navBarLayout="small">
  <wizard-step *ngIf="showHospitalStep" [canExit]="hospitalCheck" (stepEnter)="enterHospital($event)" stepTitle="Consent for Hospital">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 centered card card-outline-primary mb-3 text-justify">
          <span class="agreeContent" [innerHtml]="viewObj?.htmlContent | safeHtml"></span>
        </div>
        <div class="col-md-12 centered text-center">
          <div class="row">
            <div class="agree-container class-col-md-12">
              <mat-checkbox [(ngModel)]="hospitalCheck">I Agree</mat-checkbox>
            </div>
          </div>
          <button [disabled]="!hospitalCheck" type="button" class="btn btn-outline-info next-step float-right" nextStep>Next Step</button>
        </div>
      </div>
    </div>
  </wizard-step>
  <wizard-step *ngIf="!emailRegistration" title="Validate Date of Birth" stepTitle="Validate Date of Birth">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 centered text-center">
          <h2 class="title-dob">Insert your date of birth and click on next</h2>
          <div class="agreeContent">
            <select class="custom-select" [(ngModel)]="birthDate.month">
              <option *ngFor="let month of monthsArr" [ngValue]="month">{{month}}</option>
            </select>
            <select class="custom-select" [(ngModel)]="birthDate.day">
              <option *ngFor="let day of daysArr" [ngValue]="day">{{day}}</option>
            </select>
            <select class="custom-select" [(ngModel)]="birthDate.year">
              <option *ngFor="let year of yearsArr" [ngValue]="year">{{year}}</option>
            </select>
          </div>
          <div class="row">
            <button *ngIf="showHospitalStep" type="button" class="btn btn-outline-info next-step float-left" previousStep>Go to previous step</button>
            <button (click)="finishFunction()" type="button" class="btn btn-outline-info next-step float-right">Next Step</button>
          </div>
        </div>
      </div>
    </div>
  </wizard-step>
  <wizard-step [canEnter]="dobValid" (stepEnter)="initRegisterForm()" stepTitle="User Information">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 container">
          <div class="edit-header">
            <h1 class="user-title">{{email}}</h1>
          </div>
            <div class="container">
            <app-user-form [action]='action' [formContent]='userDetails' (onSubmitSuccess)="onSubmitSuccess($event)"></app-user-form>
          </div>
        </div>
      </div>
    </div>
  </wizard-step>
</wizard>
